import { Component, OnChanges, inject, ChangeDetectionStrategy, signal, input } from '@angular/core';
import {DrivePackageResponse} from '../../model/drive-package-response';
import {UnitSelectionService} from '../../services/unit-selection-service';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-schedule-line-drive-package',
    templateUrl: './schedule-line-drive-package.component.html',
    styleUrls: ['./schedule-line-drive-package.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DecimalPipe]
})
export class ScheduleLineDrivePackageComponent implements OnChanges {
  private readonly service = inject(UnitSelectionService);


  readonly fieldLabel = input.required<string>();
  readonly response = input.required<DrivePackageResponse>();
  readonly horsepowerDescription = signal<string>(undefined!);

  ngOnChanges() {
    const numericHorsepower = (this.response()?.Horsepower || 0);
    this.horsepowerDescription.set(numericHorsepower.toString());
    this.findHorsepowerDescription(numericHorsepower);
  }

  findHorsepowerDescription(horsepower: number): void {
    if (!isNaN(horsepower) && horsepower > 0) {
      this.service.getHorsepowerDescription(horsepower).subscribe({
        next: (description) => {
          this.horsepowerDescription.set(description);
        }
      });
    }
  }

}
